import { withDefault } from '@vy/utils';
import type { VyDate } from '@vy/utils';
import { getDefaultDates } from '../../pages/data-metering/utils/rangePickerUtils';
import { deserializeDateParam, serializeDateParam } from '../../utils/params-formatting';
import { useStateParams } from '../use-state-params';

export function useToDayParam(defaultDay?: VyDate) {
  const [_defaultFromDay, defaultToDay] = getDefaultDates();

  return useStateParams(
    withDefault(defaultDay, defaultToDay),
    'to',
    serializeDateParam,
    deserializeDateParam,
  );
}
